<template>
  <div class="dividewrapper" :style="{height: mainthickness}">
    <!-- <div class="mainline" :style="{backgroundColor: maincolor, width: mainwidth, height: mainthickness, bottom: offsetbottom }" style="z-index: 1;"></div> -->
    <!-- <div class="backgroundline" :style="{backgroundColor: secondarycolor, height: secondarythickness, bottom: offsetbottom }" style="width: 100%;"></div> -->
  </div>
</template>

<script>
export default {
  props: {
    maincolor: { type: String, default: "#cc0000" },
    secondarycolor: { type: String, default: "#eeeeee" },
    mainwidth: { type: String, default: "50px" },
    mainthickness: { type: String, default: "2px" },
    secondarythickness: { type: String, default: "1px" },
    offsetbottom: { type: String, default: "-24px" }
  }
};
</script>

<style scoped>
.dividewrapper {
  position:relative;
}
.mainline,
.backgroundline {
  position: absolute;
}
</style>


